<template>
  <div
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="500"
    class="mb-5"
  >
    <Title text="shottracker careers" />
    <div class="text-gray-500 lg:text-lg text-md font-AvenirFont">
      <p class="my-6">
        Our team is a dynamic group of experienced and passionate thinkers,
        dreamers and do-ers. Whether it's engineering, design, sales or
        analytics, we are dedicated to bringing our skills and expertise to the
        world of sports. Sounds like a match? We make it easy to apply.
      </p>

      <ul class="list-disc ml-8">
        <li>Check out our openings listed below</li>
        <li>
          Complete the ShotTracker Job Application included in the job
          description
        </li>
        <li>
          Submit your resume to
          <span class="hover:text-STblue text-STorange hover:underline">
            <a href="mailto: careers@shottracker.com"
              >careers@shottracker.com</a
            ></span
          >
        </li>
        <li>
          Note to Recruiters and Agencies: We kindly ask that no third-party agencies or recruiting firms reach out or submit candidates for this position. All candidates must apply directly through our careers page or as directed in this job listing.
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";

export default {
  name: "Description",
  components: {
    Title,
  },
};
</script>